import { useQuery } from '@tanstack/react-query';

type UseGetESIMTransferConfigParams = {
  state: string;
  services: any;
  enabled?: boolean;
};

export const useGetESIMTransferConfig = ({
  state,
  services,
  enabled = true,
}: UseGetESIMTransferConfigParams) => {
  return useQuery({
    queryKey: ['esim_transfer_config', state],
    queryFn: () => services.esimtransferConfig({ state }),
    enabled,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};
